import { PlainCheckbox } from "components/ui";
import { Colors } from "consts/colors";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { selectors, actions } from "store/continuationOrderCreate";

export const MeditLink = () => {
  const order = useAppSelector(selectors.getAllInfoSelector);
  const dispatch = useAppDispatch();

  const handleSendScansViaMeditLink = (value: boolean) => {
    dispatch(actions.setSendScansViaMeditLink(value));
  };

  return (
    <PlainCheckbox
      value={order.useMeditLink}
      onChange={handleSendScansViaMeditLink}
      label="Sending through Scanner Portal"
      labelStyle={{
        fontSize: "12px",
        lineHeight: "18px",
        color: Colors.SECONDARY,
      }}
    />
  );
};
